// extracted by mini-css-extract-plugin
export default {"welcome_placeholder":"WelcomeMessage_welcome_placeholder__b2zFF","logo_normal":"WelcomeMessage_logo_normal__EUtBK"};